import React from 'react'
import {CButton, CForm, CFormInput} from "@coreui/react";
import CustomPagination from "../../components/CustomPagination";
import ManageBookingOrdersTable from "./ManageBookingOrdersTable";
import {Link} from "react-router-dom";


const ManageBookingOrders = () => {
  
  return (
    <div>
      <ManageBookingOrdersTable />
    </div>
  );
}

export default ManageBookingOrders;
